
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexpHgQdVtRPGQW_45KX5NB9SGHBzyu60teY_450AZGfs82eV0Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/index.vue?macro=true";
import { default as loginGXAas9iM70cNnuQYAo53G7xo8iVHMTDvX8WokcBGbgIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/login.vue?macro=true";
import { default as verifyurusURIFDP_45mljUINl26Cg3qYxcbQcuKJJjrN3aboKMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/verify.vue?macro=true";
import { default as sitemapHHMz_dnMCAXo2FaK0DfaTFeEBXmAYbvbB1e9reKGy58Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/sitemap.vue?macro=true";
import { default as about_45usAWoJtUGg92iF30SP6i9jeoGRK09yEujE99oANI_t8XEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/about-us.vue?macro=true";
import { default as registerBLpMYDWgIwx5tBfoGeC9lXWOt9VqoPOCrfgncS8APywMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/register.vue?macro=true";
import { default as indexLsPiBWw03Yg_45el5pc652CnBJvY__45GbuOATGZPzWhMLYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/ben/index.vue?macro=true";
import { default as indexd6nSAtLmeC4JjmetjXJaYgLa4UhojwLsGXBcj9cnIjoMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/mel/index.vue?macro=true";
import { default as complaintsdSNcOR1wk_45UYxWuUb4O7J4_JbQAkMqvMPYF84D_lH9cMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/complaints.vue?macro=true";
import { default as contact_45us_E1HTCI_6hpjnF6Sbz3tFkRFjvHiS8ZpiLU8KJif_zMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/contact-us.vue?macro=true";
import { default as indexkkgPQZB6grIsGw45JQGH0EiVpc4x3HX_s3HvCOFcYToMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/news/index.vue?macro=true";
import { default as index98zMeK3OzgAZVHGjzKuZlA4_45swq4s9qCkF9sHNnqxMcMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/sotm/index.vue?macro=true";
import { default as indexCE2M3Harzp6vkVutnbEHHtdKiDWG2BamVygRXkyf91MMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/media/index.vue?macro=true";
import { default as indexrY__45j6EfEbgfW9AtsZAK9z3kkebnL9iRYcmKNQ0O5BgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/stuff/index.vue?macro=true";
import { default as indexoYketVQEhTTjY5Fh8Fq3tPMVz0qqWPdqSDkimJcnsJgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/index.vue?macro=true";
import { default as _91slug_93w_45R_45AnzQM1J_99u7epo8r5_yQy0GiO2WyGs3K31oqTYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/media/[slug].vue?macro=true";
import { default as partnerships4Ml5eZzIkhk386SZZ80NDl3i9cwRtiy7bydC2WGJ3IwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/partnerships.vue?macro=true";
import { default as terms_45of_45usee5RSnexN8MHndQkBKOkF1_4MHFzZQhQ9B_45Z_PHKncrgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/terms-of-use.vue?macro=true";
import { default as indexEqGCORwR8LoI94csrEmkTnRLywZ3CDj4IY7Lh6yN_451oMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/careers/index.vue?macro=true";
import { default as privacy_45policyVwzRNQsJjvq3rZMpui7VyBe6me3VlscbO8F0eKjOokcMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordnkC_ZmObOAad7pmInCEufM_Dl1GrlHjqKFAn1onuCWEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/reset-password.vue?macro=true";
import { default as indexQZQ_6MUyLHfZyFxrkXC7Samg6faYCzlEQgNPQHjNMg4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-loans/index.vue?macro=true";
import { default as indexHgdgQayy6FIrIe1XVyV4QVWvrGRrSHwe_45gnw7JywIDAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/index.vue?macro=true";
import { default as legalb1HCCczrLXiD1uxRnArsSgW_iwi0niXkcTNL9_g2x_45gMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/legal.vue?macro=true";
import { default as loginmeH_8j_45d86CiVGanVwBpZkVnj_454gOLg_45e28bn_nBvdgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/login.vue?macro=true";
import { default as forgot_45passwordVknGJrsjgGoxVW9BDTwz7Exf3x1_Z_sAPW8wM6a7r9MMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/forgot-password.vue?macro=true";
import { default as errorSI5ixQoYqZhD4MyHpybWnTOICIJxUbeDf8tI6_8vH30Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/cdr/error.vue?macro=true";
import { default as indexP9heP89_45FAo5coEVp8RIAys4Ofod7_457Xl_45873LN9VVEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/index.vue?macro=true";
import { default as _91slug_93qDm95cq80NJynuNGBGvilMch0KWw8WOFjXDCJjUD274Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/[slug].vue?macro=true";
import { default as guidesgGWzINV_45BUp5GXFtDqrA6n3n99G_TdEzeQ2jUt25IjMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/guides.vue?macro=true";
import { default as collection_45noticercQsIBCM7uw3AZtLDasNQyqOwN_45BBnoUY6YJ_45rQLBUgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/collection-notice.vue?macro=true";
import { default as index9FLzq4ZGxy7dKM_453VG70djoGO1lfu7kBIUu8MZzjEwEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/index.vue?macro=true";
import { default as register7Z0Hvzo6_cRXGCQDwo6sfD9YV3ctduJQZIHOBwrrqbgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/register.vue?macro=true";
import { default as set_45passwordqnfv4t0g4Pa9HI9L4oeQwQHkOEnrxxSdxver6bbPDlwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/guest/set-password.vue?macro=true";
import { default as welcome_45backAFERA7CVaOfbAJ5H_yFqhifWRyJDfLOrCR1z2R2pZYYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/guest/welcome-back.vue?macro=true";
import { default as index8WTwdmrHtW522JODHD0SgA0AvS1Q4iYMq6ES_454Jw1PUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/index.vue?macro=true";
import { default as _91slug_938n840YqRtSWgfdiN4RVUdfb_Au82jRAUG3PaufcoekEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/[slug].vue?macro=true";
import { default as indexMk7kPrYFgR0k98hvyai7aYB5BTkZkLYDdZvV0uFtETsMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/app/index.vue?macro=true";
import { default as post_45sale_45thank_45you_45HQCuzsWB4i7ywwbcMoDtkKc3c064WXKw1zX3ONfQXQMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/post-sale-thank-you.vue?macro=true";
import { default as thank_45youRosP8aDXM2yyOrsBxNUTkXpUytFrg4nG2fZw_457zJ1VEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/cdr/thank-you.vue?macro=true";
import { default as index9ukYIhIw0pqQP_4sCpILpaChBdJ8T1Hy1C0RNn6nSrMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/index.vue?macro=true";
import { default as indexfy70I0J1TiQvuQq4mKBbg983sy7PyhNfMT16H75X_45jYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/index.vue?macro=true";
import { default as _91slug_93829_xb_Fup373BlS8Ht6kwH2FhahSeK6W_5NI9oTcbsMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/preview/media/[slug].vue?macro=true";
import { default as indexFGVqfXC_kHF9JFTu1PqEBTJm4dB_T_gOecte_45SjiHGMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/perks/index.vue?macro=true";
import { default as indexB26WXdpteLf5aaVmWbY9Zqv7e2Vz8odQT_45qLM2HAtk0Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/index.vue?macro=true";
import { default as _91author_93cxlSANdOz8fID_a32plU7wIC0XIlkRHn6K_45zZUzDtc8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/media/author/[author].vue?macro=true";
import { default as buyer_45protection_45claimg9CeJRFwNttK_45NqzgSaf3j6gq46235RkYvs4e2xRptUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/buyer-protection-claim.vue?macro=true";
import { default as indexYxmdWPpt91V4Lp4tuId10Ax_YpH1ydDdN63oASBMvyAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/quotes/index.vue?macro=true";
import { default as thank_45you4I_45_ZndV3rJZCd4jCNM6eXaTIr_45_451FrvVmgdyXu2F9QMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/quote/thank-you.vue?macro=true";
import { default as errorDFKmvbeAVrJUL3Hj2Oh87cj3UEAXDgegbD20auKqhM8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/error.vue?macro=true";
import { default as index0a9xTPTyMBuoUE4aHedT_457vEApYXfaer_45npVavnB5a8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/index.vue?macro=true";
import { default as index2lrjQt0_DMs68NluT_ybJ_TdW_BzaVJOdehqpctiT2YMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/rewards/index.vue?macro=true";
import { default as indexUPTtv9cH7_iq91xXw98AUe_45IwjmWAXteCMEoivWn6gwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/clubplus/index.vue?macro=true";
import { default as reset_45passwordfTDSFmfzZUtZ99f_xOr0OdfK_1_45VFp4z2hKZCZBsjbAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/reset-password.vue?macro=true";
import { default as errorAlvUJ_45rD_GU_45p8mnyFgy8L6_456WxTo_kahHQW9kigQxcMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/application/error.vue?macro=true";
import { default as _91step_939Nf3tDbjNx0aNbt7PS4qicUHRc9_1DfiVUxi_sZlpksMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/quote/form/[step].vue?macro=true";
import { default as index6Mj1Ds4_45cgxTxJA2T2hwEV4CW9mFvUqTmbafM_prTwMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/index.vue?macro=true";
import { default as quote6fqnArxXcM_45dcWL2Lx5S7JuyVUDXHV8c1Qaz0OsCRf8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/quote.vue?macro=true";
import { default as forgot_45password5St_45DA26vIkLgI55CZ6PV1Tcjv3HtwUNavoqOP_fpS0Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/forgot-password.vue?macro=true";
import { default as detailsEn8dZVC4HleolgdlcKWanVT9vIrPy2K9r8bSNm1sI38Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/quote/form/details.vue?macro=true";
import { default as interest_45ratesmlLP0rhSXYrzfEY6OsZzarl3JqGeftWn54MWIQsiAf8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/interest-rates.vue?macro=true";
import { default as _91slug_93NioSBw1eABa9L4Y1hofz__4cT9YY96lK0Xf_kr3lHeMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/preview/[vertical]/[slug].vue?macro=true";
import { default as indexEP9dtmcg5Tv6XEF0_0HtvNMfdjF8CjQEzkf6orD37DAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/companies/index.vue?macro=true";
import { default as account_45settingsP5UGWG9TvmXygJiIPC_45elpL6FV_RSoqzHyoME_454N_45VIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/account-settings.vue?macro=true";
import { default as indexZPlKuTnnu_45jU9MomT9WfdoTSdqnUe_yCWlsHmn6jdnAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/onboarding/index.vue?macro=true";
import { default as live_45chatkMEwa4zBy_45XebpH4VtrOW3mSo1CbOaGm_iB5ikZL10IMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/live-chat.vue?macro=true";
import { default as post_45saleN3sfEaohYWZXF3yVtrCKZU9JBTwZ8E95YySM4xDQDn8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/post-sale.vue?macro=true";
import { default as thank_45youd7T68bSg987O_45wEn47vSXgt0OsFwuhvRoFXGcpLduzwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/quote/thank-you.vue?macro=true";
import { default as comprehensivedJ2xQj0B1PtO62gUPihY6D0xZF5kXpaDQPCtQo7MfngMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/comprehensive.vue?macro=true";
import { default as _91slug_93PeCAb9Y1d72ykcdSvXRhkeIHZfTiUgU8CqC7tkaQJxYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/preview/[slug].vue?macro=true";
import { default as add0rHgompL9Tn1nD32z4Wktyd_iWVpVdzOBt4H3KlGv6gMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/partners/add.vue?macro=true";
import { default as index1QJerjceRHdncbR_MOSnkW68nYOWFGJd1s2hKRHogCQMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue?macro=true";
import { default as _91response_939vElvKb0elFT2z_45Q2PmkrRXINfgXRe_45nY_45gBpIGNEDkMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue?macro=true";
import { default as schedule_45callback82QBfbPWuCPiRQ9KBb2_iu9jTfygjxbr3sk6gPrEcaYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/schedule-callback.vue?macro=true";
import { default as _91slug_93Xm1wK9iUvDu4urQIg0FvHB9qJnBk5YYuj48u_9khM9MMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue?macro=true";
import { default as set_45passwordRMtFXw82fgiB5w79XSB4lC3pzIE1vuBWX5TPWYlEPRIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/guest/set-password.vue?macro=true";
import { default as welcome_45back5cjkCwxKRoRGwPpAjmLH7SrSbRVFUtz7CzJ_45QsbZXQkMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/guest/welcome-back.vue?macro=true";
import { default as thank_45you_FcywezIR420rsmImZ5wuEju9JoIO2RjWrT2buzn3uwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/application/thank-you.vue?macro=true";
import { default as live_45chat_45bMG3LqIP6M2CRbBAdoWyXIztW91rPqm6j0ZwyH9OAlmAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/live-chat-b.vue?macro=true";
import { default as indexHm1uFL_45baVB433_aBhYfZrAQwunW5cOnH7ia5GDCEa4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/calculators/index.vue?macro=true";
import { default as _91step_938BiDA8IcTAizYjwixrHQAhghpd1lpwigr_jcWZwdMQYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/quote/form/[step].vue?macro=true";
import { default as thank_45youX08cNnacMmp89CcN071_7pgBttyO1DCOPdZj7AD6Ug0Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/thank-you.vue?macro=true";
import { default as _91slug_93bYmoN_TKZk54ZDu_eQy9eJgblj9XEjOXF2Mxt1d1J1cMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue?macro=true";
import { default as merge_Vmb5D4xEfZgIaJIyKydv9upY9HdTSxQdgjmAHAly0gMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/authorization/merge.vue?macro=true";
import { default as index7Srq0rOOj1MRK5Q2WTJ1g9rg_45kQrDDbMy93niEZ62HkMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/offers/index.vue?macro=true";
import { default as addqBImwaPVcwUaSucn_45jHj5PppVwnDCEEbLsBGHRGAGs0Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/partners/add.vue?macro=true";
import { default as _91type_939FljwItMgNd9kfNYGvYLLuCvEfn_457wpCZoSzbwslxMwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/calculators/[type].vue?macro=true";
import { default as detailsXMaq6KI2HNJkX4gEKSEURr2QVUduY7SsqrQijeKi2z4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/quote/form/details.vue?macro=true";
import { default as callbackNTLrHiwkgAq1xdBGewIo29pYTQuX9jaHlZyoMQhQHpYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/callback.vue?macro=true";
import { default as digital_45eicUP9YCoroThmiTye9_45PU7q9_45yLVEZOmswKJ6fBNSsWsIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/application/digital-eic.vue?macro=true";
import { default as _91step_93WO7XgsntAA3WQvVmp_fLy1Vz9I1prTxd7JcIGMoajzAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/form/[step].vue?macro=true";
import { default as thank_45youSTi1gSkvEVUV6a_JPNjxjI5k0xbsE26geKHemJ6CjkUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue?macro=true";
import { default as _91step_93TwKJ5sUiOkuLEkaVBf15Xy4z_45XVm4ld0Bfjedv2BZNgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue?macro=true";
import { default as _91author_93DyVIaf7MkRF8jViLr3SJsYTc_45zLlEqiP5je6EZDcYnEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/author/[author].vue?macro=true";
import { default as comparisonFPJBzLVg66_45pJdj9WZfIR0cMgq5GbH9O3PPqVcwo4hUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/comparison.vue?macro=true";
import { default as detailstPVqvb9B01IM_tB6cd8_45aEW4SFKPEofiIgz_45d6TOldwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/quote/form/details.vue?macro=true";
import { default as resultszkb1l41p51RSpssuQkK7LcmOmoPbJhhEBymXoaoMvaMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/quote/form/results.vue?macro=true";
import { default as callbackciRI3Ocls4EEziKREcUYEEvqxs_45We4lOoRJW5_SbXqgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/authorization/callback.vue?macro=true";
import { default as index5ODyRzG_455hXJbEV6hVMmN2P6HyO5lIBI980yIOsqBDcMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/[category]/index.vue?macro=true";
import { default as signupxuAcQve6Ugp33fkCpQP5GZjPP8KNbdJo7nF6WVzAGosMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/partners/signup.vue?macro=true";
import { default as thank_45you63lIHIAdt4WrOp9SPjsfbB872lbEps_kcI_45KTKNXOGEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue?macro=true";
import { default as _91step_93GXJUjdQHTl2FnlDoUrQ0kcgSsJNXiKiPDTA7lnJL_45OwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/form/[step].vue?macro=true";
import { default as _91step_93o9yI2S4vpClhKCAL6t3CqLO9GO79dlQU_NcDeGzMqCgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93Bltf6MoZVevheCGvCpbXmkM7p_0YQUAZwzMaiBgqRy4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue?macro=true";
import { default as step0LOwUvFIYKfPwTOEV4xK46btuQovXMJa_45hAyrB_OTM9wMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue?macro=true";
import { default as existing_45customersvkXNODTbV_45zRUNOI_raCiyn99c1EakNNArr4qf68OQAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/existing-customers.vue?macro=true";
import { default as thank_45yousKGNX0L8XhOCxZOB_450ZbFZCg4QG4nGwzQ9_45VoCTJQzwMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue?macro=true";
import { default as detailsWpPKqeL3qvLZm94Vwygge0WjcgHFt7wJ4YqnCkqBqb8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/form/details.vue?macro=true";
import { default as detailsx9hpR0lz4saC41eMKRhp_G87lsRFrIMX5TTCBMJhv_MMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/quote/form/details.vue?macro=true";
import { default as _91step_93i_45i1_45flVmpNAdotrJhwA1D4rtlRw3i0DFhT3S7HDasIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue?macro=true";
import { default as rebate90ldXwmlFYEe_E_45gR6cqtga14twgjpfP4kkaOgsR_45wYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue?macro=true";
import { default as _91step_93xzdMkiApgE10Q8e8WvSfV4_45hSPtskWJLn_4539LSqg2zoMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/[step].vue?macro=true";
import { default as detailsrO6d2ke7Av8KLjdctGlCLsIfvNi5nzoIWPRsxNI59tUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/form/details.vue?macro=true";
import { default as step04anzaTtiFhozbFTo9k8ok8sCGK9VHomP83BPB7X44mIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue?macro=true";
import { default as indexV_454Xr2CSuvdZrTnfkcRMhJ2O3GhEkOdmVmulI4rEQMgMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue?macro=true";
import { default as indexi5YHZoJgQIBUREhCo847mjGuj5sUnb28D2BEqUzwU90Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue?macro=true";
import { default as detailsc4GZ6CGjGYfWE2fwlcwTW7pUclJ3E4xcAN_oSQhTMCYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue?macro=true";
import { default as terms_45and_45conditions6QwdVQzHpEtsrPEvxO0kBLIyUFsoMv_454D6DGKFzB_45ekMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue?macro=true";
import { default as _91step_93BMSDsjw3pEUa92ukQ2tq2hUmKekUm_tkiOmldZYlQOMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/applicationV2/[step].vue?macro=true";
import { default as indexcRlHpQxXlzAL_T4AoEWdQjpUL9BYUbq3HWUzOfMHtuUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue?macro=true";
import { default as detailsT8mw0l864Vo3zUMAp30c9W2g0mFPwWqfbkkOUhPNFq8Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue?macro=true";
import { default as indexx60xiJwvZqIrGea11zm1ocXVHJwHapSashJ9CJNouCYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue?macro=true";
import { default as successoR4v_452ACkcXkQqHgrkKjx8ZJJvZGQftwHzusVN1_8ZIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue?macro=true";
import { default as claim_45offer6uS_QBUWz39_45aMNADkL_45MPyPsoV6LMMxsiScPZfKxVkMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue?macro=true";
import { default as lic_45detailsSapYWLl_459H4pd_eeSyVHLlIWHWw3__tpgbPc30u4bXAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue?macro=true";
import { default as _91step_93dwIbEPUjZNxMxoLxeqYi0kfGhfiLFNXr3jQRkouX9YAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue?macro=true";
import { default as indexOYogeCbI_45mX2BNTSUuZUzCEGNFZG0_45AttRzMwj7Gj5YMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue?macro=true";
import { default as _91slug_93lA9aQ8swIN03R_IORyjFoQg5sb9bHcYFO_45PgUgcmDQMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue?macro=true";
import { default as index2k8KDsEiAYxfWsVCqWmOJEFbHa_45qbHMlUbRVY2vrHwYMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/payment/index.vue?macro=true";
import { default as _91step_93KcVDn75Xrv5QVAHzui8_Fln2Z5HwD_45euw0FUgJgynZIMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue?macro=true";
import { default as thank_45youIXAwagpLkWIyjSurahura9LhT7f3el3h2Mn9BL_45ofxMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/application/thank-you.vue?macro=true";
import { default as index2sSY4aStwSFsPHdm492NyGHW5WgpbtjpihgG6P7S1EoMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue?macro=true";
import { default as indexI4U_45AiWlXjeLQKKCOCZd2jLkHUHNG4qVAkkFfslMNvsMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue?macro=true";
import { default as details_4588k3z5yZI3VRKyYcCsaEIAIGaK3jxw7VdeQIbf04QcMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue?macro=true";
import { default as expiredySVQ7FSMd3faYbkcBZSLX5xRSZpiynXn5ADqslMtVkEMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue?macro=true";
import { default as indexz5iDTS22MAUbI_wf5sCagfOYE69GpCeQb8jFitjs9ToMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue?macro=true";
import { default as thank_45youVtE8SzwLhkXCez5DmPXqGSAz6SqUNSI4xbZ5uT5VrY4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue?macro=true";
import { default as indexnoJGl_AFfDATEcV81nYeXrXc6B7nw_45iIKczmZ_45GXN0YMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/thank-you-callback-apply/index.vue?macro=true";
import { default as detailsPEltuRH_VwYU1eGoCMagFzUP0eg0bHZH9wJipJZSBTUMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue?macro=true";
import { default as pre_45assesment_45sRRX9_45EUAvYR1ZxPE__vCAcNgNjn5v6GEL39xxtcDoMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/application/pre-assesment.vue?macro=true";
import { default as confirmationO1yX_14RbTWHdk9TrGuqt_GRRQ33IXa7kYjMwN5g4scMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue?macro=true";
import { default as completionYdF0jiTPGMyArtfRs8SBmn_45_45hoxzCGQwn_USsan6fiAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue?macro=true";
import { default as quotes_45resultsHfCkKUF4_45qFpxGkGF30IsRthy07tgGFR2nL0eucGzNAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue?macro=true";
import { default as signuppFs69dnMFJrTnTKh2HZYrRWduZy4u4vtqHOX94gQkBMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/partners/signup.vue?macro=true";
import { default as confirmationKkPWOqv7xreb1GbrRnfC3GP20VcBHiBb4zCwf8D_4598gMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue?macro=true";
import { default as _91step_93skyODVOTkjJ0B0yl7jM3iGXeGR4qNwLQNpZL3757OggMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue?macro=true";
import { default as _91step_93w1gHbRZy7BFfvEFfMGAAMafC4s1yT4p9OwAELzAcLkcMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue?macro=true";
import { default as _91step_93pfpn95dNFJD_45HEGYvWJngDYhEdLCR1oaZZxQcQRHy_4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue?macro=true";
import { default as _91step_93Pm_4WM5f_uHhgnl28OIEzQU8_45AMDKOMeanVk54fNHKMMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue?macro=true";
import { default as indexAKgwy1qWUhMCNGpvzztXogL7ue4XswgN_VVlx_aeGp0Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue?macro=true";
import { default as additional_45detailsDUm2yIxE_djEU049pFpIOI_zm11rw_zXQTiV6ySp08QMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue?macro=true";
import { default as _91step_93N2ROUkCy83_g_45zdMNLNCGxjRZGFsJUTH9_45_45pB4o9_45MkMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue?macro=true";
import { default as signup_45completed6wYAHmvwt_ufkFcvoVDiC15z9UbSu4U4nj5slPEvbkAMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/partners/signup-completed.vue?macro=true";
import { default as _91step_93w2dXp_CcEP86yADaDfd2p_g9zx05PMMbmaeNmnXHqr4Meta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue?macro=true";
import { default as indexRxrLDeLRyvoeaDCt629C4dmZQYsK9RinK_455qcWZsgogMeta } from "/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":["mh-middleware"]},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/verify.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/sitemap.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/about-us.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: {"middleware":["mh-middleware"]},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/register.vue")
  },
  {
    name: "ben",
    path: "/ben",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/ben/index.vue")
  },
  {
    name: "mel",
    path: "/mel",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/mel/index.vue")
  },
  {
    name: "complaints",
    path: "/complaints",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/complaints.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/contact-us.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/news/index.vue")
  },
  {
    name: "sotm",
    path: "/sotm",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/sotm/index.vue")
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/media/index.vue")
  },
  {
    name: "stuff",
    path: "/stuff",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/stuff/index.vue")
  },
  {
    name: "energy",
    path: "/energy",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/index.vue")
  },
  {
    name: "media-slug",
    path: "/media/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/media/[slug].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/partnerships.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/terms-of-use.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/careers/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(reset_45passwordnkC_ZmObOAad7pmInCEufM_Dl1GrlHjqKFAn1onuCWEMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/reset-password.vue")
  },
  {
    name: "car-loans",
    path: "/car-loans",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-loans/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexHgdgQayy6FIrIe1XVyV4QVWvrGRrSHwe_45gnw7JywIDAMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-legal",
    path: "/dashboard/legal",
    meta: { ...(legalb1HCCczrLXiD1uxRnArsSgW_iwi0niXkcTNL9_g2x_45gMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/legal.vue")
  },
  {
    name: "dashboard-login",
    path: "/dashboard/login",
    meta: { ...(loginmeH_8j_45d86CiVGanVwBpZkVnj_454gOLg_45e28bn_nBvdgMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/login.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: {"middleware":["mh-middleware"]},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/forgot-password.vue")
  },
  {
    name: "energy-cdr-error",
    path: "/energy/cdr/error",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/cdr/error.vue")
  },
  {
    name: "home-loans",
    path: "/home-loans",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/index.vue")
  },
  {
    name: "vertical-slug",
    path: "/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/[slug].vue")
  },
  {
    name: "vertical-guides",
    path: "/:vertical()/guides",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "collection-notice",
    path: "/collection-notice",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/collection-notice.vue")
  },
  {
    name: "credit-cards",
    path: "/credit-cards",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/index.vue")
  },
  {
    name: "dashboard-register",
    path: "/dashboard/register",
    meta: { ...(register7Z0Hvzo6_cRXGCQDwo6sfD9YV3ctduJQZIHOBwrrqbgMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/register.vue")
  },
  {
    name: "guest-set-password",
    path: "/guest/set-password",
    meta: { ...(set_45passwordqnfv4t0g4Pa9HI9L4oeQwQHkOEnrxxSdxver6bbPDlwMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/guest/set-password.vue")
  },
  {
    name: "guest-welcome-back",
    path: "/guest/welcome-back",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/guest/welcome-back.vue")
  },
  {
    name: "car-insurance",
    path: "/car-insurance",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/index.vue")
  },
  {
    name: "credit-cards-slug",
    path: "/credit-cards/:slug()",
    meta: _91slug_938n840YqRtSWgfdiN4RVUdfb_Au82jRAUG3PaufcoekEMeta || {},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/[slug].vue")
  },
  {
    name: "dashboard-app",
    path: "/dashboard/app",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/app/index.vue")
  },
  {
    name: "post-sale-thank-you",
    path: "/post-sale-thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/post-sale-thank-you.vue")
  },
  {
    name: "energy-cdr-thank-you",
    path: "/energy/cdr/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/cdr/thank-you.vue")
  },
  {
    name: "life-insurance",
    path: "/life-insurance",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/index.vue")
  },
  {
    name: "personal-loans",
    path: "/personal-loans",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/index.vue")
  },
  {
    name: "preview-media-slug",
    path: "/preview/media/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/preview/media/[slug].vue")
  },
  {
    name: "dashboard-perks",
    path: "/dashboard/perks",
    meta: { ...(indexFGVqfXC_kHF9JFTu1PqEBTJm4dB_T_gOecte_45SjiHGMMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/perks/index.vue")
  },
  {
    name: "expert-analysis",
    path: "/expert-analysis",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/index.vue")
  },
  {
    name: "media-author-author",
    path: "/media/author/:author()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/media/author/[author].vue")
  },
  {
    name: "buyer-protection-claim",
    path: "/buyer-protection-claim",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/buyer-protection-claim.vue")
  },
  {
    name: "dashboard-quotes",
    path: "/dashboard/quotes",
    meta: { ...(indexYxmdWPpt91V4Lp4tuId10Ax_YpH1ydDdN63oASBMvyAMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/quotes/index.vue")
  },
  {
    name: "energy-quote-thank-you",
    path: "/energy/quote/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/quote/thank-you.vue")
  },
  {
    name: "health-insurance-error",
    path: "/health-insurance/error",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/error.vue")
  },
  {
    name: "health-insurance",
    path: "/health-insurance",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/index.vue")
  },
  {
    name: "dashboard-rewards",
    path: "/dashboard/rewards",
    props: {"verificationNeeded":true},
    meta: { ...(index2lrjQt0_DMs68NluT_ybJ_TdW_BzaVJOdehqpctiT2YMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/rewards/index.vue")
  },
  {
    name: "dashboard-clubplus",
    path: "/dashboard/clubplus",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/clubplus/index.vue")
  },
  {
    name: "dashboard-reset-password",
    path: "/dashboard/reset-password",
    meta: { ...(reset_45passwordfTDSFmfzZUtZ99f_xOr0OdfK_1_45VFp4z2hKZCZBsjbAMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/reset-password.vue")
  },
  {
    name: "energy-application-error",
    path: "/energy/application/error",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/application/error.vue")
  },
  {
    name: "energy-quote-form-step",
    path: "/energy/quote/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/quote/form/[step].vue")
  },
  {
    name: "life-insurance-aip",
    path: "/life-insurance/aip",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/index.vue")
  },
  {
    name: "life-insurance-aip-quote",
    path: "/life-insurance/aip/quote",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/quote.vue")
  },
  {
    name: "dashboard-forgot-password",
    path: "/dashboard/forgot-password",
    meta: {"middleware":["mh-middleware"]},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/forgot-password.vue")
  },
  {
    name: "energy-quote-form-details",
    path: "/energy/quote/form/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/quote/form/details.vue")
  },
  {
    name: "home-loans-interest-rates",
    path: "/home-loans/interest-rates",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/interest-rates.vue")
  },
  {
    name: "preview-vertical-slug",
    path: "/preview/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/preview/[vertical]/[slug].vue")
  },
  {
    name: "vertical-companies",
    path: "/:vertical()/companies",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  },
  {
    name: "dashboard-account-settings",
    path: "/dashboard/account-settings",
    meta: { ...(account_45settingsP5UGWG9TvmXygJiIPC_45elpL6FV_RSoqzHyoME_454N_45VIMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/account-settings.vue")
  },
  {
    name: "dashboard-onboarding",
    path: "/dashboard/onboarding",
    meta: {"middleware":["mh-middleware"]},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/onboarding/index.vue")
  },
  {
    name: "health-insurance-live-chat",
    path: "/health-insurance/live-chat",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/live-chat.vue")
  },
  {
    name: "health-insurance-post-sale",
    path: "/health-insurance/post-sale",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/post-sale.vue")
  },
  {
    name: "home-loans-quote-thank-you",
    path: "/home-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-comprehensive",
    path: "/car-insurance/comprehensive",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/comprehensive.vue")
  },
  {
    name: "credit-cards-preview-slug",
    path: "/credit-cards/preview/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/preview/[slug].vue")
  },
  {
    name: "life-insurance-partners-add",
    path: "/life-insurance/partners/add",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/partners/add.vue")
  },
  {
    name: schedule_45callback82QBfbPWuCPiRQ9KBb2_iu9jTfygjxbr3sk6gPrEcaYMeta?.name,
    path: "/:vertical()/schedule-callback",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/schedule-callback.vue"),
    children: [
  {
    name: "vertical-schedule-callback",
    path: "",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue")
  },
  {
    name: "vertical-schedule-callback-response",
    path: ":response()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue")
  }
]
  },
  {
    name: "credit-cards-redirect-slug",
    path: "/credit-cards/redirect/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue")
  },
  {
    name: "dashboard-guest-set-password",
    path: "/dashboard/guest/set-password",
    meta: set_45passwordRMtFXw82fgiB5w79XSB4lC3pzIE1vuBWX5TPWYlEPRIMeta || {},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/guest/set-password.vue")
  },
  {
    name: "dashboard-guest-welcome-back",
    path: "/dashboard/guest/welcome-back",
    meta: welcome_45back5cjkCwxKRoRGwPpAjmLH7SrSbRVFUtz7CzJ_45QsbZXQkMeta || {},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/guest/welcome-back.vue")
  },
  {
    name: "energy-application-thank-you",
    path: "/energy/application/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/application/thank-you.vue")
  },
  {
    name: "health-insurance-live-chat-b",
    path: "/health-insurance/live-chat-b",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/live-chat-b.vue")
  },
  {
    name: "home-loans-calculators",
    path: "/home-loans/calculators",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/calculators/index.vue")
  },
  {
    name: "home-loans-quote-form-step",
    path: "/home-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/quote/form/[step].vue")
  },
  {
    name: "life-insurance-aip-thank-you",
    path: "/life-insurance/aip/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/thank-you.vue")
  },
  {
    name: "car-insurance-redirect-slug",
    path: "/car-insurance/redirect/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue")
  },
  {
    name: "dashboard-authorization-merge",
    path: "/dashboard/authorization/merge",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/authorization/merge.vue")
  },
  {
    name: "health-insurance-offers",
    path: "/health-insurance/offers",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/offers/index.vue")
  },
  {
    name: "health-insurance-partners-add",
    path: "/health-insurance/partners/add",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/partners/add.vue")
  },
  {
    name: "home-loans-calculators-type",
    path: "/home-loans/calculators/:type()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/calculators/[type].vue")
  },
  {
    name: "home-loans-quote-form-details",
    path: "/home-loans/quote/form/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/home-loans/quote/form/details.vue")
  },
  {
    name: "life-insurance-quote-callback",
    path: "/life-insurance/quote/callback",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/callback.vue")
  },
  {
    name: "energy-application-digital-eic",
    path: "/energy/application/digital-eic",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/energy/application/digital-eic.vue")
  },
  {
    name: "life-insurance-aip-form-step",
    path: "/life-insurance/aip/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/aip/form/[step].vue")
  },
  {
    name: "personal-loans-quote-thank-you",
    path: "/personal-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-quote-form-step",
    path: "/car-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-author-author",
    path: "/expert-analysis/author/:author()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/author/[author].vue")
  },
  {
    name: "life-insurance-quote-comparison",
    path: "/life-insurance/quote/comparison",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/comparison.vue")
  },
  {
    name: "car-insurance-quote-form-details",
    path: "/car-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/quote/form/details.vue")
  },
  {
    name: "car-insurance-quote-form-results",
    path: "/car-insurance/quote/form/results",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/car-insurance/quote/form/results.vue")
  },
  {
    name: "dashboard-authorization-callback",
    path: "/dashboard/authorization/callback",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/authorization/callback.vue")
  },
  {
    name: "expert-analysis-category",
    path: "/expert-analysis/:category()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/[category]/index.vue")
  },
  {
    name: "health-insurance-partners-signup",
    path: "/health-insurance/partners/signup",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/partners/signup.vue")
  },
  {
    name: "health-insurance-quote-thank-you",
    path: "/health-insurance/quote/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-step",
    path: "/life-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/form/[step].vue")
  },
  {
    name: "personal-loans-quote-form-step",
    path: "/personal-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-category-slug",
    path: "/expert-analysis/:category()/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue")
  },
  {
    name: "health-insurance-quote-form-step0",
    path: "/health-insurance/quote/form/step0",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue")
  },
  {
    name: "life-insurance-existing-customers",
    path: "/life-insurance/existing-customers",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/existing-customers.vue")
  },
  {
    name: "life-insurance-partners-thank-you",
    path: "/life-insurance/partners/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-details",
    path: "/life-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/form/details.vue")
  },
  {
    name: "personal-loans-quote-form-details",
    path: "/personal-loans/quote/form/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/personal-loans/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-form-step",
    path: "/health-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue")
  },
  {
    name: "dashboard-vault-product-rebate",
    path: "/dashboard/vault/:product([^/]*)*/rebate",
    meta: { ...(rebate90ldXwmlFYEe_E_45gR6cqtga14twgjpfP4kkaOgsR_45wYMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue")
  },
  {
    name: "health-insurance-application-step",
    path: "/health-insurance/application/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/[step].vue")
  },
  {
    name: "health-insurance-quote-form-details",
    path: "/health-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-policy-step0",
    path: "/health-insurance/quote/policy/step0",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue")
  },
  {
    name: "health-insurance-quote-resume",
    path: "/health-insurance/quote/resume",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue")
  },
  {
    name: "life-insurance-quote-customer",
    path: "/life-insurance/quote/customer",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue")
  },
  {
    name: "dashboard-vault-product-details",
    path: "/dashboard/vault/:product([^/]*)*/details",
    meta: { ...(detailsc4GZ6CGjGYfWE2fwlcwTW7pUclJ3E4xcAN_oSQhTMCYMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue")
  },
  {
    name: "buyer-protection-terms-and-conditions",
    path: "/buyer-protection/terms-and-conditions",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue")
  },
  {
    name: "health-insurance-applicationV2-step",
    path: "/health-insurance/applicationV2/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/applicationV2/[step].vue")
  },
  {
    name: "health-insurance-quote-customer",
    path: "/health-insurance/quote/customer",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue")
  },
  {
    name: "health-insurance-quote-policy-details",
    path: "/health-insurance/quote/policy/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue")
  },
  {
    name: "health-insurance-quotes-results",
    path: "/health-insurance/quotes-results",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue")
  },
  {
    name: "life-insurance-quote-customer-success",
    path: "/life-insurance/quote/customer/success",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue")
  },
  {
    name: "dashboard-offers-vertical-claim-offer",
    path: "/dashboard/offers/:vertical()/claim-offer",
    meta: { ...(claim_45offer6uS_QBUWz39_45aMNADkL_45MPyPsoV6LMMxsiScPZfKxVkMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue")
  },
  {
    name: "dashboard-vault-product-lic-details",
    path: "/dashboard/vault/:product([^/]*)*/lic-details",
    meta: { ...(lic_45detailsSapYWLl_459H4pd_eeSyVHLlIWHWw3__tpgbPc30u4bXAMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue")
  },
  {
    name: "health-insurance-quote-policy-step-step",
    path: "/health-insurance/quote/policy/step/:step()",
    meta: _91step_93dwIbEPUjZNxMxoLxeqYi0kfGhfiLFNXr3jQRkouX9YAMeta || {},
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc",
    path: "/health-insurance/visitors-visa-ovhc",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue")
  },
  {
    name: "preview-expert-analysis-vertical-slug",
    path: "/preview/expert-analysis/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue")
  },
  {
    name: "health-insurance-application-payment",
    path: "/health-insurance/application/payment",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/payment/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-step",
    path: "/health-insurance/visitors-visa-ovhc/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue")
  },
  {
    name: "life-insurance-quote-application-thank-you",
    path: "/life-insurance/quote/application/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/application/thank-you.vue")
  },
  {
    name: "health-insurance-application-thankyou",
    path: "/health-insurance/application/thankyou",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue")
  },
  {
    name: "health-insurance-rate-rise-calculator",
    path: "/health-insurance/rate-rise-calculator",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-details",
    path: "/health-insurance/visitors-visa-ovhc/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue")
  },
  {
    name: "health-insurance-application-payment-expired",
    path: "/health-insurance/application/payment/expired",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue")
  },
  {
    name: "life-insurance-income-protection-quote",
    path: "/life-insurance/income-protection/quote",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-thank-you",
    path: "/health-insurance/visitors-visa-ovhc/thank-you",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue")
  },
  {
    name: "life-insurance-thank-you-callback-apply",
    path: "/life-insurance/thank-you-callback-apply",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/thank-you-callback-apply/index.vue")
  },
  {
    name: "life-insurance-income-protection-quote-details",
    path: "/life-insurance/income-protection/quote/details",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue")
  },
  {
    name: "life-insurance-quote-application-pre-assesment",
    path: "/life-insurance/quote/application/pre-assesment",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/quote/application/pre-assesment.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-confirmation",
    path: "/health-insurance/visitors-visa-ovhc/confirmation",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-vertical-completion",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/completion",
    meta: { ...(completionYdF0jiTPGMyArtfRs8SBmn_45_45hoxzCGQwn_USsan6fiAMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-quotes-results",
    path: "/health-insurance/visitors-visa-ovhc/quotes-results",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-partners-signup",
    path: "/health-insurance/visitors-visa-ovhc/partners/signup",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/partners/signup.vue")
  },
  {
    name: "life-insurance-income-protection-quote-confirmation",
    path: "/life-insurance/income-protection/quote/confirmation",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-form-energy-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/energy/step/:step()",
    meta: { ...(_91step_93skyODVOTkjJ0B0yl7jM3iGXeGR4qNwLQNpZL3757OggMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-generic-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/generic/step/:step()",
    meta: { ...(_91step_93w1gHbRZy7BFfvEFfMGAAMafC4s1yT4p9OwAELzAcLkcMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-application-step",
    path: "/health-insurance/visitors-visa-ovhc/application/:step()",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-home-loan-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/home-loan/step/:step()",
    meta: { ...(_91step_93Pm_4WM5f_uHhgnl28OIEzQU8_45AMDKOMeanVk54fNHKMMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-form",
    path: "/health-insurance/students-offer/:university()/form",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue")
  },
  {
    name: "dashboard-vault-product-vertical-additional-details",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/additional-details",
    meta: { ...(additional_45detailsDUm2yIxE_djEU049pFpIOI_zm11rw_zXQTiV6ySp08QMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue")
  },
  {
    name: "dashboard-vault-product-form-life-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/life-insurance/step/:step()",
    meta: { ...(_91step_93N2ROUkCy83_g_45zdMNLNCGxjRZGFsJUTH9_45_45pB4o9_45MkMeta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-partners-signup-completed",
    path: "/health-insurance/visitors-visa-ovhc/partners/signup-completed",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/partners/signup-completed.vue")
  },
  {
    name: "dashboard-vault-product-form-health-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/health-insurance/step/:step()",
    meta: { ...(_91step_93w2dXp_CcEP86yADaDfd2p_g9zx05PMMbmaeNmnXHqr4Meta || {}), ...{"middleware":["mh-middleware"]} },
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-terms-conditions",
    path: "/health-insurance/students-offer/:university()/terms-conditions",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue")
  },
  {
    name: "Guides",
    path: "/credit-cards/guides",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "Companies",
    path: "/credit-cards/companies",
    component: () => import("/codebuild/output/src3811682644/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  }
]